import { createContext as y, useContext as C, useReducer as R, useRef as x, useEffect as S, useState as E } from "react";
import { jsx as f } from "react/jsx-runtime";
import { createEventEmitter as B } from "@made-people/grease-event-emitter";
import { productProviderContextContext as $, useProductBase as T, useProductPurchaseStatus as q, productVariantDimensionSchema as I, productSimpleSchema as F, productWithVariantsSchema as U, productMediaImageSchema as Q, productBundleSchema as L } from "@made-people/grease-product";
import { moneySchema as s } from "@made-people/grease-money";
import { z as e } from "zod";
const w = y(void 0), _ = () => {
  const t = C(w);
  if (!t)
    throw new Error(
      "useCartEventEmitter must be used inside a <CartEventContext />"
    );
  return t;
}, D = y(void 0), mt = (t) => {
  const { children: r, ...a } = t;
  return /* @__PURE__ */ f(D.Provider, { value: a, children: r });
}, z = () => {
  const t = C(D);
  return t || { additionalData: void 0 };
}, N = {
  fetchCart: "fetchCart",
  addToCart: "addToCart",
  addBundleToCart: "addBundleToCart",
  removeFromCart: "removeFromCart",
  updateQuantity: "updateQuantity",
  updateComment: "updateComment",
  addVoucher: "addVoucher",
  removeVoucher: "removeVoucher"
};
function G(t, r) {
  if (!Object.keys(N).some(
    (a) => r.type.startsWith(`${a}.`)
  ))
    throw new Error(`Unhandled action type: ${r.type}`);
  if (r.type.endsWith("Request"))
    return { ...t, loading: !0 };
  if (r.type.endsWith("Success"))
    return { ...t, loading: !1, cart: r.payload, error: void 0 };
  if (r.type.endsWith("Error"))
    return console.error(r.payload), { ...t, loading: !1, error: r.payload };
  throw new Error(`Unhandled action type state: ${r.type}`);
}
const H = B(), P = y(void 0), k = y(void 0), M = y(
  void 0
), J = (t) => {
  const [r, a] = R(G, {
    loading: !1,
    cart: t.initialCart
  }), c = x(!0);
  S(() => {
    if (c.current) {
      c.current = !1;
      return;
    }
    t.initialCart && a({ type: "fetchCart.Success", payload: t.initialCart });
  }, [t.initialCart]);
  const n = {
    eventEmitter: t.cartEventEmitter ?? H
  };
  return /* @__PURE__ */ f(
    w.Provider,
    {
      value: n,
      children: /* @__PURE__ */ f(M.Provider, { value: t.cartClientDriver, children: /* @__PURE__ */ f(k.Provider, { value: r, children: /* @__PURE__ */ f(P.Provider, { value: a, children: t.children }) }) })
    }
  );
};
J.displayName = "CartProvider";
const K = () => {
  const t = C(P);
  if (!t)
    throw new Error("useCartDispatch must be used inside a <CartProvider />");
  return t;
}, X = () => {
  const t = C(M);
  if (!t)
    throw new Error("useCartDispatch must be used inside a <CartProvider />");
  return t;
}, A = () => {
  const t = C(k);
  if (!t)
    throw new Error("useCartState must be used inside a <CartProvider />");
  return t;
}, Y = (t) => {
  const { eventEmitter: r } = _(), { additionalData: a } = z(), c = K(), n = X(), d = A(), u = x(void 0), h = C($);
  return S(() => {
    u.current = d.cart;
  }, [d]), async (m) => {
    c({ type: `${t}.Request` });
    try {
      const o = u.current, i = await n[t](m);
      c({ type: `${t}.Success`, payload: i });
      let v = "unknown";
      h && (v = h.type);
      const b = a && typeof a == "object" && !Array.isArray(a) && a !== null ? { ...a, location: v } : { location: v };
      r.emit(t, {
        oldCart: o,
        cart: i,
        payload: m,
        additionalData: b
      });
    } catch (o) {
      const i = o instanceof Error ? o : new Error(`${o}`);
      throw c({ type: `${t}.Error`, payload: i }), i;
    }
  };
}, Z = 1e3, p = (t, r) => {
  const a = Y(t), [c, n] = E("default"), [d, u] = E(void 0), h = (r == null ? void 0 : r.loadingCompleteTimeout) ?? Z;
  return {
    loadingState: c,
    error: d,
    execute: async (m) => {
      u(void 0), n("loading");
      try {
        await a(m), n("complete"), setTimeout(() => n("default"), h), r != null && r.success && r.success();
      } catch (o) {
        n("default");
        const i = o;
        throw u(i), r != null && r.error && r.error(i), i;
      }
    }
  };
}, Ct = () => {
  const t = p("fetchCart");
  return S(() => {
    t.execute(void 0);
  }, []), null;
}, vt = (t) => {
  const r = T(), a = p("addToCart", t);
  async function c(n, d = 1) {
    if (!n.inventory.inStock) {
      console.warn("Product is out of stock, disable add to cart button.");
      return;
    }
    await a.execute({
      product: r,
      itemId: n.dimensionValue,
      quantity: d
    });
  }
  return {
    quickAddToCartMethod: {
      execute: c,
      loadingState: a.loadingState
    }
  };
}, ft = (t) => {
  const r = T(), a = q(), c = p("addToCart", t), n = p("updateQuantity", t), d = p("removeFromCart", t), { cart: u } = A(), h = a.status === "available" ? a.availableItemId : void 0, m = a.status === "out-of-stock" ? a.outOfStockItemId : void 0, o = u == null ? void 0 : u.items.find(
    (l) => l.id === h
  ), i = (o == null ? void 0 : o.quantity) ?? 0;
  async function v(l = 1) {
    o && l > 0 ? await n.execute({
      lineId: o.lineId,
      quantity: o.quantity + l
    }) : l > 0 && h && await c.execute({
      product: r,
      itemId: h,
      quantity: l
    });
  }
  async function b(l = 1) {
    o && l > 0 && await d.execute({
      lineId: o.lineId,
      quantity: l,
      removedItem: o
    });
  }
  return {
    addToCartMethod: {
      execute: v,
      loadingState: o ? n.loadingState : c.loadingState
    },
    removeFromCartMethod: {
      execute: b,
      loadingState: d.loadingState
    },
    quantityInCart: i,
    outOfStockItemId: m,
    isAvailable: a.status === "available",
    isOutOfStock: a.status === "out-of-stock",
    isDiscontinued: a.status === "discontinued"
  };
}, V = e.object({
  name: e.string().describe("The name of the voucher"),
  affectsOrderTotal: e.boolean().describe("Whether the voucher affects the order total"),
  discount: s.describe("The discount of the voucher"),
  displayName: e.string().optional().describe("Customer facing name to show instead of the voucher code"),
  isRemovable: e.boolean().optional().describe("Whether the customer is allowed to remove the voucher")
}), O = V.extend({
  type: e.literal("code"),
  code: e.string().describe("The code of the voucher")
}), tt = V.extend({
  type: e.literal("auto")
}), et = e.discriminatedUnion("type", [
  O,
  tt
]), j = e.object({
  discounted: e.boolean(),
  priceEach: s.describe("The price of the item"),
  priceEachWithoutDiscount: s.describe(
    "The price of the item without discount"
  ),
  priceEachWithoutTax: s.describe(
    "The price of the item without tax, useful for tracking"
  ),
  totalPrice: s.describe("The total price of the item")
}), W = e.object({
  lineId: e.string(),
  id: e.string(),
  sku: e.string(),
  quantity: e.number(),
  metaData: e.record(e.unknown()).optional(),
  price: j
}), rt = W.extend({
  type: e.literal("product"),
  itemDimensions: e.array(I),
  product: e.union([F, U])
}), at = e.object({
  id: e.string(),
  quantity: e.number(),
  price: j,
  itemDimensions: e.array(I),
  image: Q.optional(),
  name: e.string(),
  slug: e.string().optional(),
  description: e.string().optional(),
  shortDescription: e.string().optional()
}), ot = W.extend({
  type: e.literal("bundle"),
  bundleItems: e.array(at),
  product: L
}), nt = e.union([rt, ot]), ct = e.object({
  grandTotal: s,
  shipping: s,
  subtotalWithoutTax: s,
  subtotal: s,
  discount: s.optional(),
  tax: s.optional()
}), g = e.object({
  code: e.string(),
  name: e.string()
}), pt = e.object({
  cartId: e.string(),
  currencyCode: e.string(),
  languageCode: e.string(),
  paymentMethod: g.optional(),
  shippingMethod: g.optional(),
  vouchers: et.array(),
  totals: ct.optional(),
  items: e.array(nt)
});
export {
  mt as CartEventAdditionalDataProvider,
  w as CartEventEmitterContext,
  Ct as CartInitialize,
  J as CartProvider,
  Z as DEFAULT_COMPLETE_TIMEOUT,
  tt as autoVoucherSchema,
  W as basicCartItemSchema,
  ot as bundleItemSchema,
  N as cartClientMethods,
  H as cartEventEmitter,
  g as cartMethodSchema,
  G as cartReducer,
  pt as cartSchema,
  ct as cartTotals,
  O as codeVoucherSchema,
  nt as lineItemSchema,
  rt as productItemSchema,
  X as useCartClient,
  K as useCartDispatch,
  z as useCartEventAdditionalData,
  _ as useCartEventEmitter,
  p as useCartMethod,
  Y as useCartMethodExecute,
  A as useCartState,
  vt as useQuickShopAddToCart,
  ft as useUpdateCart,
  et as voucherSchema
};
